if (!customElements.get("ootd-item")) {
    customElements.define(
      "ootd-item",
      class OotdItem extends HTMLElement{
        constructor() {
            super();
            this.defaultSize = ['M', '34', 'C'];
            this.colorName = ['Color', 'Colour'];                        
        }

        init(){
            // 产品json数据
            const scriptEl = this.querySelector('#_ql_product');
            if(!scriptEl) return;
            const jsonStr = scriptEl.textContent.trim();
            if(!jsonStr) return;
            try{
                const jsonData = JSON.parse(jsonStr);
                this.productData = jsonData;
            } catch(error){
                return;
            }

            this.variants = this.productData.variants;

            this.form = this.querySelector('form.product-card-form');
            this.selectVariant = this.form.querySelector('input[name="id"]');
            
            // 初次加载，默认选中的 ootd_color 和 默认尺码
            const ootd_color = this.getAttribute('data-ootd-color');
            let select = this.querySelector(`.product-card__options .variant-picker__field input[value="${ootd_color}"]`);
            if(!select) return;
            select.checked = true;
            this.defaultSize.forEach((val) => {
                let option = this.querySelector(`.product-card__options .variant-picker__field select option[value="${val}"]`);
                if(!option) return;
                const optionParent = option.parentElement;
                if(!optionParent) return;
                optionParent.value = val;
            });


            const selectOptions = this.getSelectOptions();
            this.changeVariantId(selectOptions);

            // change 事件
            this.optionsContainers.forEach((el) => {
                const optionName = el.getAttribute('data-option-name');
                
                if(this.colorName.includes(optionName)){
                    el.addEventListener('change', (e) => {
                        if(e.target.tagName === 'INPUT'){
                            const selectOptions = this.getSelectOptions();
                            this.changeVariantId(selectOptions);
                        }
                    })

                } else {
                    el.addEventListener('change', (e) => {
                        if(e.target.tagName === 'SELECT'){
                            const selectOptions = this.getSelectOptions();
                            this.changeVariantId(selectOptions);
                        }
                    })
                }
                
            });            
        }

        // 获取选中的options值 selectOptions
        getSelectOptions() {
            let selectOptions = [];
            this.optionsContainers = this.querySelectorAll('.product-card__options .variant-picker__field');
            this.optionsContainers.forEach((el) => {
                const optionName = el.getAttribute('data-option-name');
                const labelEl = el.querySelector('.variant-picker__field .selected-value');
                
                if(this.colorName.includes(optionName)){
                    let select = el.querySelector('input:checked');
                    let color = select.value;
                    const imgEl = this.querySelector('.product-card__image--main img');
                    const imgSrc = select.getAttribute('data-variant-image');
                    const imgSrcse = select.getAttribute('data-image-srcset');
                    if (imgSrc) {
                        imgEl.src = imgSrc;
                        imgEl.srcset = imgSrcse;
                    } 
                    labelEl.innerHTML = color;
                    selectOptions.push(color);
                }else{
                    let select = el.querySelector('select');
                    labelEl.innerHTML = select.value;
                    selectOptions.push(select.value);
                }
            });
            return selectOptions;
        }

        // 修改加购form中的产品变体id
        changeVariantId(selectOptions){
            // 找到selectOptions对应的variant
            const foundVariant = this.variants.find(variant => selectOptions?.every((value, index) => {
                const optionName = 'option' + (index + 1);
                return value == variant[optionName];
            }));
            if (foundVariant) this.selectVariant.setAttribute('value', foundVariant.id);
        }
      }
    );
  }
  